import {useState} from "react"

/**
 * Prend le type de data en paramètres (optionnel)
 * Génère un objet (qui peut être pris en destructuring)
 * Une fois useFetch appelée, on peut utiliser fetchApi pour générer un data
 * Voir un exemple dans Mesquestions0.jsx
 * @param  {[type]} type le type de data (tableau ou objet par ex)
 * @return {object}      retour possible de filtrer à l'aide du destructuring
 */
export function useFetch (type =null) {

	const [loading, setLoading] = useState(true)
	const [data, setData] = useState(type)
	const [data2, setData2] = useState(type)
	const [errors, setErrors] = useState(null)

	const fetchApi = (url='api', options) => {
		fetch("https://maths-au-quotidien.fr/react-automaths/"+url+".php", {
		      method: 'POST',
		      body: JSON.stringify(options)
		    })
		    .then(response => response.json())
		    .then(datas => {
		    	setData(datas)
		    })
		    .catch(err => {
		    	setErrors('err')
		    })
		    .finally(setLoading(false))		
	}

	const fetchApi2 = (url='api', options) => {
		fetch("https://maths-au-quotidien.fr/react-automaths/"+url+".php", {
		      method: 'POST',
		      body: JSON.stringify(options)
		    })
		    .then(response => response.json())
		    .then(datas => {
		    	setData2(datas)
		    })
		    .catch(err => {
		    	setErrors('err')
		    })
		    .finally(setLoading(false))		
	}

	return {
		loading, data, errors, setErrors, fetchApi, setData, fetchApi2, data2, setData2
	}
}